export function useSessionStorage() {
  const clientId = '';
  const isBrowser: boolean = ((): boolean => {
    return typeof window !== 'undefined';
  })();

  const getSessionItem = (key: string): string => {
    return (
      (isBrowser &&
        sessionStorage.getItem(`IdentityService.${clientId}.${key}`)) ||
      ''
    );
  };

  const setSessionItem = (key: string, value: string): void => {
    if (isBrowser) {
      sessionStorage.setItem(`IdentityService.${clientId}.${key}`, value);
    }
  };

  const removeSessionItem = (key: string): void => {
    if (isBrowser) {
      sessionStorage.removeItem(`IdentityService.${clientId}.${key}`);
    }
  };

  return {
    getSessionItem,
    setSessionItem,
    removeSessionItem,
  };
}
